import {
  DescribeParametersCommandOutput,
  GetParameterCommandInput,
  SSMClient,
  ParameterMetadata,
} from '@aws-sdk/client-ssm';
import { DescribeParametersCommandInput } from '@aws-sdk/client-ssm/dist-types/commands/DescribeParametersCommand';
import { createQueryKeys } from '@lukemorales/query-key-factory';
import {
  VITE_AWS_ROLE_ARN_CONFIG_ENTRY_READER,
  VITE_AWS_ROLE_ARN_CONFIG_ENTRY_WRITER,
  VITE_AWS_ROLE_ARN_CONFIG_SCHEMA_READER,
  VITE_AWS_ROLE_ARN_CONFIG_SCHEMA_WRITER,
  VITE_AWS_ROLE_ARN_TERMINAL_ENTRY_READER,
  VITE_AWS_ROLE_ARN_TERMINAL_ENTRY_WRITER,
  VITE_AWS_ROLE_ARN_TERMINAL_SCHEMA_READER,
  VITE_AWS_ROLE_ARN_TERMINAL_SCHEMA_WRITER,
} from 'common/constants/env.constants.ts';
import { EQueryKeys } from 'common/enums/query-keys.enums.ts';
import { IAwsPrerequisitesServiceRes } from 'domains/aws/interfaces/aws.interfaces.ts';
import {
  awsDescribeParametersService,
  awsGetParameterCommandService,
  awsInitGroupService,
} from 'domains/aws/services/aws.service.ts';

export const awsQueryKeys = createQueryKeys(EQueryKeys.AwsQueryKeys, {
  awsInitGroupReader: (token: string) => ({
    queryKey: ['group-reader', token],
    queryFn: (): Promise<IAwsPrerequisitesServiceRes> =>
      awsInitGroupService(token, VITE_AWS_ROLE_ARN_TERMINAL_SCHEMA_READER),
  }),
  awsInitGroupWriter: (token: string) => ({
    queryKey: ['group-writer', token],
    queryFn: (): Promise<IAwsPrerequisitesServiceRes> =>
      awsInitGroupService(token, VITE_AWS_ROLE_ARN_TERMINAL_SCHEMA_WRITER),
  }),
  awsInitEntryReader: (token: string) => ({
    queryKey: ['entry-reader', token],
    queryFn: (): Promise<IAwsPrerequisitesServiceRes> =>
      awsInitGroupService(token, VITE_AWS_ROLE_ARN_TERMINAL_ENTRY_READER),
  }),
  awsInitEntryWriter: (token: string) => ({
    queryKey: ['entry-writer', token],
    queryFn: (): Promise<IAwsPrerequisitesServiceRes> =>
      awsInitGroupService(token, VITE_AWS_ROLE_ARN_TERMINAL_ENTRY_WRITER),
  }),
  awsDescribeParameters: (ssmClient: SSMClient, input: DescribeParametersCommandInput) => ({
    queryKey: ['aws-describe-parameters', input],
    queryFn: (): Promise<ParameterMetadata[]> => awsDescribeParametersService(ssmClient, input),
  }),
  awsGetParameterCommand: (ssmClient: SSMClient, input: GetParameterCommandInput) => ({
    queryKey: ['aws-get-parameters', input],
    queryFn: (): Promise<DescribeParametersCommandOutput> => awsGetParameterCommandService(ssmClient, input),
  }),

  awsInitConfigsGroupReader: (token: string) => ({
    queryKey: ['configs-group-reader', token],
    queryFn: (): Promise<IAwsPrerequisitesServiceRes> =>
      awsInitGroupService(token, VITE_AWS_ROLE_ARN_CONFIG_SCHEMA_READER),
  }),
  awsInitConfigsGroupWriter: (token: string) => ({
    queryKey: ['configs-group-writer', token],
    queryFn: (): Promise<IAwsPrerequisitesServiceRes> =>
      awsInitGroupService(token, VITE_AWS_ROLE_ARN_CONFIG_SCHEMA_WRITER),
  }),
  awsInitConfigsEntryReader: (token: string) => ({
    queryKey: ['configs-entry-reader', token],
    queryFn: (): Promise<IAwsPrerequisitesServiceRes> =>
      awsInitGroupService(token, VITE_AWS_ROLE_ARN_CONFIG_ENTRY_READER),
  }),
  awsInitConfigsEntryWriter: (token: string) => ({
    queryKey: ['configs-entry-writer', token],
    queryFn: (): Promise<IAwsPrerequisitesServiceRes> =>
      awsInitGroupService(token, VITE_AWS_ROLE_ARN_CONFIG_ENTRY_WRITER),
  }),
});
